export enum SocketEvent {
    NEW_BOOKING = 'NEW_BOOKING',
    BOOKING_STATUS_COMPLETED = 'BOOKING_STATUS_COMPLETED',
    BOOKING_STATUS_CANCELLED = 'BOOKING_STATUS_CANCELLED',
    NEW_USER_UPDATE='NEW_USER_UPDATE'
  }
  